import React from 'react';

import { green, orange, red } from 'data/colors';
import statuses from 'data/policy_plan_statuses';
import { money as moneyFormatter } from 'utils/format/money';
import renewalStatuses from 'data/renewal_method_statuses';
import Actions from './Actions';

const statusName = (value) => {
  const status = statuses.find((item) => item.value == value);
  return status == null ? '' : status.label;
};

const renewalStatusName = (value) => {
  const status = renewalStatuses.find((item) => item.value == value);
  return status == null ? '' : status.label;
};

const sessionsTitle = (sessions) => (sessions == '0' ? 'TA' : sessions);
const columns = [
  {
    name: 'Enterprise',
    selector: 'attributes.enterprise_name',
    sortable: true,
  },
  {
    name: 'Plan Name',
    selector: 'attributes.name',
    sortable: true,
    width: '90px',
  },
  {
    name: 'Sessions',
    selector: 'attributes.sessions',
    width: '80px',
    sortable: true,
    cell: (row) => sessionsTitle(row.attributes.sessions),
    sortFunction: (rowA, rowB) => {
      const a = rowA.attributes.sessions == 0 ? 1000 : rowA.attributes.sessions;
      const b = rowB.attributes.sessions == 0 ? 1000 : rowB.attributes.sessions;

      if (a > b) {
        return 1;
      }

      if (b > a) {
        return -1;
      }

      return 0;
    },
  },
  {
    name: 'Effective Date',
    selector: 'attributes.effective_date_formatted',
    sortable: true,
    width: '115px',
    sortFunction: (a, b) => a.attributes.effective_date_int - b.attributes.effective_date_int,
  },
  {
    name: 'Renewal Date',
    selector: 'attributes.renewal_date_formatted',
    sortable: true,
    width: '115px',
    sortFunction: (a, b) => a.attributes.renewal_date_int - b.attributes.renewal_date_int,
  },
  {
    name: 'Status',
    selector: 'attributes.status',
    sortable: true,
    width: '100px',
    cell: (row) => statusName(row.attributes.status),
  },
  {
    name: 'EEs',
    selector: 'attributes.employees_covered',
    width: '70px',
    sortable: true,
    cell: (row) => row.attributes.employees_covered_title,
  },
  {
    name: 'Renewal',
    selector: (row) => row.attributes.renewal_method,
    width: '120px',
    sortable: true,
    cell: (row) => renewalStatusName(row.attributes.renewal_method),
    conditionalCellStyles: [
      {
        when: (row) => row.attributes.renewal_method === 'automatic',
        style: {
          color: green,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'adjusted',
        style: {
          color: orange,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'terminated',
        style: {
          color: red,
        },
      },
    ],
  },
  {
    name: 'One-Time',
    selector: (row) => row.attributes.onetime_total,
    width: '110px',
    sortable: true,
    cell: (row) => moneyFormatter(row.attributes.onetime_total, row.attributes.currency.title),
  },
  {
    name: 'Billing',
    selector: 'attributes.billing',
    width: '70px',
    sortable: true,
  },
  {
    name: 'Premium',
    selector: (row) => (row.attributes.payment_mode == 'monthly'
      ? row.attributes.monthly_total
      : row.attributes.annual_total),
    width: '110px',
    sortable: true,
    cell: (row) => moneyFormatter(
      row.attributes.payment_mode == 'monthly'
        ? row.attributes.monthly_total
        : row.attributes.annual_total,
      row.attributes.currency.title,
    ),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '90px',
    right: true,
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
